"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var duration_1 = __importDefault(require("dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
var scorm12FormatTime = function (timeInMs) {
    var time = dayjs_1.default.duration(timeInMs);
    var hours = "".concat(Math.min(Math.floor(time.asHours()), 9999)).padStart(4, "0");
    var minutes = "".concat(time.minutes()).padStart(2, "0");
    var seconds = "".concat(time.seconds()).padStart(2, "0");
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds, ".00");
};
var scorm2004FormatSessionTime = function (timeInMs) {
    var time = dayjs_1.default.duration(timeInMs);
    var hours = "".concat(Math.min(Math.floor(time.asHours()), 9999));
    var minutes = "".concat(time.minutes());
    var seconds = "".concat(time.seconds());
    return "PT".concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
};
var scorm2004FormatInteractionTimestamp = function (timestampInMs) {
    var time = (0, dayjs_1.default)(timestampInMs);
    var monthNumber = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    var year = time.year().toString();
    var month = monthNumber[time.month()].toString();
    var day = time.date().toString();
    var hours = time.hour().toString().toString().padStart(2, "0");
    var minutes = time.minute().toString().toString().padStart(2, "0");
    var seconds = time.second().toString().toString().padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hours, ":").concat(minutes, ":").concat(seconds, ".0Z");
};
var computeLMSnumber = function (value) {
    if (value !== null && !Number.isNaN(Number(value)))
        return Number(value);
    return null;
};
exports.default = { scorm12FormatTime: scorm12FormatTime, scorm2004FormatSessionTime: scorm2004FormatSessionTime, scorm2004FormatInteractionTimestamp: scorm2004FormatInteractionTimestamp, computeLMSnumber: computeLMSnumber };
//# sourceMappingURL=utils.js.map